import { useCallback } from 'react';

import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

export default function AppletSignInModal({
  open,
  onDismiss,
  loginUrl,
  signUpUrl,
}: {
  open: boolean;
  onDismiss: () => void;
  loginUrl: string;
  signUpUrl: string;
}) {
  const handleOpenChange = useCallback(
    (next: boolean) => {
      if (!next) onDismiss();
    },
    [onDismiss],
  );

  return (
    <Modal
      open={open}
      onOpenChange={handleOpenChange}
      title="Sign in to continue"
      description="Create an account or sign in to use this feature. You can explore this page, but submitting work requires an account."
      maxWidth={480}
      footer={
        <div className="flex flex-wrap items-center gap-3">
          <Button variant="tertiary" type="button" onClick={onDismiss}>
            Dismiss
          </Button>
          <div className="ml-auto flex gap-3">
            <a href={loginUrl}>
              <Button variant="secondary" type="button">
                Sign in
              </Button>
            </a>
            <a href={signUpUrl}>
              <Button variant="primary" type="button">
                Sign up
              </Button>
            </a>
          </div>
        </div>
      }
    >
      <></>
    </Modal>
  );
}
